import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Breadcrumbs, Grid, Typography, Chip } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import OverviewStyles from "pages/NftDep/Auction/OverviewStyles";
import {
  setCurrentPage,
  getPicTreeGoldChestTrend,
  setPicTreeChestType
} from "actions";
import * as C from "components";
import * as V from "styles/variables";
import TreasureChestStats from "components/PicTree/Item/TreasureChestStats";
import GenericEchart from "components/Charts/GenericEchart";
import CalendarRangePickerAll from "components/Calendar/CalendarRangePickerPicTreeAll";
import SingleSelect from "components/Select/SingleSelect";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    position: "-webkit-sticky",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  titleTodaysSales: {
    paddingTop: 8,
    paddingBottom: 16,
    fontSize: 12,
  },
  fillRemailSpace: {
    flex: "auto",
  },
  sectionTop: {
    marginTop: -16,
    marginBottom: 8,
    [theme.breakpoints.down("sm")]: {
      marginTop: 8,
    },
  },
  breadcrumbs: {
    marginTop: 16,
    minHeight: 30,
  },
  loaderBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 280,
  },
  loaderBarImg: {
    width: 40,
  },
  dataCellTd: {
    fontSize: 13,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
    textAlign: "right",
    verticalAlign: "middle",
    borderBottom: "1px solid #eee6e6",
    borderRight: "1px solid #eee6e6",
    height: 45,
  },
  lblGameName: {
    color: "#000",
    fontSize: 13,
    minWidth: 160,
  },
  tTd: {
    height: 44,
    width: 250,
    paddingLeft: "1rem",
    borderBottom: "1px solid #eee",
    borderCollapse: "collapse",
  },
  selectGameTxt: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 280,
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const PicTreeTreasureChest = ({
  setCurrentPage,
  getPicTreeGoldChestTrend,
  pageTopLoader,
  goldChestTrend,
  dateRangePicTree,
  setPicTreeChestType,
}) => {
  const classes = useStyles();
  const [chartState, setChartState] = useState(true);
  const [chestType, setChestType] = useState({ name: "金", value: "gold" });
  const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTree[0] !== null &&
      dateRangePicTree[1] !== null &&
      initialDataCall
    ) {
      getPicTreeGoldChestTrend();
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

    useEffect(() => {
    if (!initialDataCall) {
      getPicTreeGoldChestTrend();
    }
  }, [chestType]);

  const handleChange = (event) => {
    setChestType(event.target.value);
    setPicTreeChestType(event.target.value);
  };

  const generateLegend = (trendData) => {
    if (!trendData || trendData.length === 0) return {};
    const keys = Object.keys(trendData[0])
      .filter((k) => k !== "date")
      .sort((a, b) => Number(b) - Number(a)); // 降順ソート

    const legend = {};
    keys.forEach((k) => {
      legend[k] = `${k}コイン`;
    });
    return legend;
  };

  const legendGoldChestTrend = generateLegend(goldChestTrend);

  return (
    <C.ContentWrapper>
      <Grid
        container
        direction="row"
        className={classes.sectionTop}
        justifyContent="space-between"
      >
        <Grid item>
          <Breadcrumbs separator="›" className={classes.breadcrumbs}>
            <Typography>PicTrée 全体</Typography>
            <Typography variant="body1">課金・報酬</Typography>
            <Typography variant="body1">宝箱</Typography>
            <Typography variant="body1">日別排出件数</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item className={classes.fillRemailSpace}></Grid>
        <Grid item>
          <CalendarRangePickerAll
            mDate={"2024/04/13"}
            page="pictree/all/treasure-chest/daily-count"
            pictree
          />
        </Grid>
      </Grid>

      <Grid
        container
        spacing={0}
        direction="row"
        style={{ marginTop: 8, marginRight: 8, marginBottom: 8 }}
        justifyContent="flex-start"
      >
        <Grid item style={{ marginTop: 0, marginLeft: 8, marginBottom: 8 }}>
          <SingleSelect
            selected={chestType}
            options={[
              { name: `金`, value: "gold" },
              { name: `レインボー`, value: "rainbow" },
            ]}
            handleChange={handleChange}
            helperText="宝箱のタイプ"
          />
        </Grid>
      </Grid>

      {goldChestTrend.length > 0 &&
        <TreasureChestStats loading={pageTopLoader} />
      }

      <Grid container spacing={1} className={classes.gridSection}>
        <Grid item xs={12} md={12} lg={12}>
          {pageTopLoader ? (
            <div className={classes.loaderBox}>
              <img
                className={classes.loaderBarImg}
                src={`/static/images/loader-bar.gif`}
              />
            </div>
          ) : chartState ? (
            goldChestTrend.length > 0 ? (
              <GenericEchart
                legend={legendGoldChestTrend}
                xAisData={goldChestTrend[0]["date"]}
                seriesData={goldChestTrend}
                chartType="bar"
                colorConfig={V.genericColorPallette}
                yAxisConfig={[
                  { name: "排出件数", type: "value" },
                ]}
              />
            ) : (
              <div className={classes.selectGameTxt}>
                <Chip
                  label="No Data"
                  style={{
                    color: V.textColor,
                    backgroundColor: V.placeholderColor,
                  }}
                />
              </div>
            )
          ) : null}
        </Grid>
      </Grid>
    </C.ContentWrapper>
  );
};

PicTreeTreasureChest.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  loading: state.nftDep.loading,
  pageTopLoader: state.page.pageTopLoader,
  goldChestTrend: state.pictree.goldChestTrend,
  dateRangePicTree: state.page.dateRangePicTree,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPicTreeGoldChestTrend: (param) => dispatch(getPicTreeGoldChestTrend(param)),
  setPicTreeChestType: (param) => dispatch(setPicTreeChestType(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(OverviewStyles, { withTheme: true })(PicTreeTreasureChest));
